import { useEffect, useState } from "react";
import { SelectListItem } from "../../components/input/SelectList";
import { SimpleOption } from "../../components/input/SimpleListbox";
import Select from "../../components/input/Select";

interface Props {
	prompts: SelectListItem[];
	updateSelectedPrompt: (id: string) => void;
}

export default function ReactivatePromptForm(props: Props) {
	const [selectedPrompt, setSelectedPrompt] = useState(props.prompts[0].value.toString());

	useEffect(() => {
		props.updateSelectedPrompt(selectedPrompt);
	}, [selectedPrompt]);

	const promptOptions = props.prompts.map((p) => {
		return {
			value: p.value,
			label: p.text,
		} as SimpleOption;
	});

	return (
		<Select
			value={selectedPrompt}
			setValue={(v) => setSelectedPrompt(v as string)}
			simpleListBoxId="promptDropdown"
			options={promptOptions}
			label="Prompt Name:"
			fieldClasses="pt-3"
			simpleListBoxClasses="w-full"
		/>
	);
}
